import qs from "qs";
import axios, { type AxiosRequestConfig } from "axios";
import { getSagApiUrl } from "@/api/http-client-helpers";
import { addXBtmidHeaderInterceptor } from "@/api/interceptors/x-btmid-header-interceptor";
import { addSagAuthInterceptor } from "@/shared/http-clients/sag-auth-interceptor";
import { logException } from "@/shared/utils/logger/use-app-logger";

/**
 * Axios basic configuration
 * Some general configuration can be added like timeout, headers, params etc. More details can be found on https://github.com/axios/axios
 * */
const config: AxiosRequestConfig = {
    baseURL: getSagApiUrl("trefik"),
    responseType: "json",
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "comma" }), // Separate array elements with comma during serialization
};

/**
 * Creating the instance of Axios
 * It is because, in large scale application we may need to consume APIs from more than single server,
 * So, may need to create multiple http client with different config
 * Only this client will be used rather than axios in the application
 **/
const httpClient = axios.create(config);

/** Adding the request/response interceptors */
addSagAuthInterceptor(httpClient);
addXBtmidHeaderInterceptor(httpClient);

httpClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        logException("trefik-api-http-client", error, {}, true);
        return Promise.reject(new Error(error));
    },
);

export { httpClient as TrefikHttpClient };
